/* eslint-disable */
// Disabled for hacktimer line:8, no-unused-vars lint error
import React from "react";
import { BrowserRouter, Route } from "react-router-dom";
import { AppLayout } from "./layout.jsx";

//used for setInterval/setTimeout, clearTimeout when tab is not active or browser minimized
import hacktimer from "hacktimer";

let ControllerContext;

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        ControllerContext = React.createContext(this.props.controller);
    }

    componentDidMount() {
        const recaptcha = document.createElement("script");
        const geoComplySdk = document.createElement("script");

        recaptcha.async = true;
        recaptcha.src = "https://www.google.com/recaptcha/api.js";
        recaptcha.id = "google-reCaptcha";

        geoComplySdk.async = true;
        geoComplySdk.src = configurationSettings?.geoComplySKD;
        geoComplySdk.id = "geo-sdk";

        if (configurationSettings?.reCaptchaSiteKey && !document.body.querySelector("#google-reCaptcha")) {
            document.body.appendChild(recaptcha);
        }

        setTimeout(() => {
            if (configurationSettings?.geoComplySdk && !document.body.querySelector("#geo-sdk")) {
                document.body.appendChild(geoComplySdk);
            }
        }, 4000);
    }

    render() {
        return (
            <BrowserRouter basename={configurationSettings.webRoot}>
                <ControllerContext.Provider value={this.props.controller}>
                    <Route
                        render={(props) => (
                            <AppLayout
                                {...props}
                                controller={this.props.controller}
                                config={this.props.config}
                                subscriptionManager={this.props.subscriptionManager}
                            />
                        )}
                    />
                </ControllerContext.Provider>
            </BrowserRouter>
        );
    }
}

export { App };
